import { environment } from "../../../environments/environment";

export const withTreeShakeableDevTools = environment.withDevtools;
